import React from "react";
import styled from "styled-components";
import { colors } from "../../../styles/style";
import { MilestoneCard } from "./MilestoneCard";
import { MilestoneWarningBadge } from "./MilestoneWarningBadge";
import { HeaderText, SmallestText } from "../../shared/SharedStyles";
import { useNavigate } from "react-router-dom";
import { milestonesData } from "../../../common/constants";
import { canUseFeature, featureForPath } from "../../../common/plan";
import { useBabyContext } from "../../../context/BabyContext";

export const MilestoneList = () => {
  const navigate = useNavigate();
  const { babyHasActivePayment, isBabyAdmin, babyAdminName } = useBabyContext();

  const isLocked = (url: string) => {
    const feature = featureForPath(url);
    return feature ? !canUseFeature(feature, babyHasActivePayment) : false;
  };

  return (
    <Container>
      <MilestonesHeader>
        <HeaderText>Upcoming milestones</HeaderText>
        <SmallButton onClick={() => navigate("/milestones")}>
          See All
        </SmallButton>
      </MilestonesHeader>
      <ListedMilestones>
        {milestonesData.map((milestone, index) => (
          <MilestoneCard
            key={index}
            $icon_src={milestone.iconSrc}
            title={milestone.title}
            width="170px"
            $max_width=""
            $min_width=""
            onClick={() => navigate(milestone.url)}
            $bgColor={isLocked(milestone.url) ? colors.lightPeach : ""}
            isNew={milestone.isNew}
            isLocked={isLocked(milestone.url)}
          />
        ))}
      </ListedMilestones>
      {babyHasActivePayment === false && (
        <MilestoneWarningBadge
          /* A visitor on somebody else's baby is told who to ask. Sending them
             to the paywall would sell them a subscription that does not unlock
             the baby they are looking at. */
          text={
            isBabyAdmin === false
              ? babyAdminName
                ? `${babyAdminName} looks after this baby. Ask them to upgrade to unlock every milestone book.`
                : `Ask whoever set this baby up to upgrade, and every milestone book unlocks for all of you.`
              : `You are currently not subscribed to our app. Please subscribe to access all features.`
          }
          onClick={() => {
            if (isBabyAdmin === false) return;
            navigate("/settings");
          }}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const MilestonesHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 16px 24px 16px;
`;

const SmallButton = styled.button`
  border: 1px solid ${colors.darkBrown};
  border-radius: 31px;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  background-color: transparent;
  color: ${colors.softBrown};
  ${SmallestText};
  cursor: pointer;
`;

const ListedMilestones = styled.div`
  display: flex;
  gap: 12px;
  margin: 0;
  margin-bottom: 12px;
  padding-left: 16px;
  overflow-x: scroll;
  position: relative;
  &::-webkit-scrollbar {
    width: 0.5em;
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -16px;
    width: 16px;
  }

  &::after {
    content: "";
    flex-shrink: 0;
  }
`;
